<template>
  <div :class="!isHTML || isTooltip ? 'description-inline' : 'description-inline-block'" v-if="isDescription || hasSlot" :id="id">
    <template v-if="isTooltip">
      <w-tooltip v-if="isHTML" :placement="description.placement">
        <template v-if="hasSlot">
          <slot />
        </template>

        <span v-else v-html="getDescription" />
      </w-tooltip>

      <w-tooltip v-else :tooltip="getDescription" :placement="description.placement" />
    </template>

    <template v-else>
      <span class="description-content" v-if="isHTML">
        <slot v-if="hasSlot" />

        <span v-else v-html="getDescription" />
      </span>

      <span class="description-content" v-else>
        <br v-if="isNewLine" />
        {{ getDescription }}
      </span>
    </template>
  </div>
</template>

<script>
import titleMixin from '../mixins/titleMixin';

export default {
  name: 'w-description',
  mixins: [titleMixin],
  props: {
    model: {
      type: Object,
      required: false
    },
    id: {
      type: [String, Boolean],
      default: false
    },
    // #region te wartości były używane zanim zostały zebrane do obiektu description w titleMixin
    value: {
      type: String,
      default: undefined,
      required: false
    },
    tooltip: {
      type: Boolean,
      default: null,
      required: false
    },
    htmlContent: {
      type: Boolean,
      default: null,
      required: false
    },
    placement: {
      type: String,
      default: null
    }
    // #endregion
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    isHTML() {
      return this.isHtmlContent || this.hasSlot;
    }
  }
};
</script>

<style>
.description-block {
  display: block;
}
.description-inline {
  display: inline;
}
.description-content {
  color: gray;
}
</style>
